// only word page includes Office.js script
export const runningInWord = () => typeof Office !== 'undefined';
